import { z } from 'zod'
import { FailureInputSchema, FailureReportSchema } from '../guidance/playwright-failure/schema'

export const PlaywrightAnalysisSchema = z.object({
  analysis_id: z.string(),
  task_id: z.string().nullable().optional(),
  status: z.string(),
  created_at: z.string(),
  input: FailureInputSchema,
  report: FailureReportSchema.nullable(),
})
export const PlaywrightAnalysesSchema = z.object({
  analyses: z.array(PlaywrightAnalysisSchema),
  total: z.number().int().nonnegative(),
  processing: z.number().int().nonnegative(),
  completed: z.number().int().nonnegative(),
  failed: z.number().int().nonnegative(),
  offset: z.number().int().nonnegative(),
  limit: z.number().int().positive(),
})
export type PlaywrightAnalyses = z.infer<typeof PlaywrightAnalysesSchema>
